import { gql } from 'graphql-request'

export namespace HomeInventoryItemQueries {
  export const QUERY_KEY = 'getHomeInventoryItems'

  export function getHomeInventoryItems() {
    return gql`
      query HomeInventoryItems {
        homeInventoryItems {
          id
          name
          quantity
        }
      }
    `
  }
}
